import {countries} from "country-codes-flags-phone-codes";
import Select from "react-select";
import React from "react";

export const CustomSelectCountries = ({selectedCountry, setSelectedCountry, isMobile, bg = '#171923'}) => {
    const customStyles = {
        control: (styles, state) => ({
            ...styles,
            backgroundColor: bg,
            border: 'none',
            borderRadius: '12px',
            color: "#fff",
            height: isMobile ? '40px':'52px',
            width: '125px',
            boxShadow: 'none',
            fontSize: '18px',
            '&:hover' : {
                outline: 'none'
            }
        }),
        option: (styles, { isSelected, isFocused }) => ({
            ...styles,
            backgroundColor: isSelected
                ? "#6200ea"
                : isFocused
                    ? "#3a3a4b"
                    : "#1e1e2f",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            fontSize: '18px',
            alignItems: "center",
        }),
        menu: (styles) => ({
            ...styles,
            height: '208px',
            marginTop: '8px',
            borderRadius: '8px',
            backgroundColor: bg,
        }),
        menuList: (styles) => ({
            ...styles,
            borderRadius: '8px',
            backgroundColor: "#171923",
            boxShadow: "0px -4px 20px 1px #6F41D280 inset !important",
            height: '208px',
            padding: "0",
            '&::-webkit-scrollbar': {
                width: '0'
            },
            // '&::-webkit-scrollbar-track': {
            //     background: '#1e1e2f',
            // },
            // '&::-webkit-scrollbar-thumb': {
            //     backgroundColor: '#6200ea',
            //     borderRadius: '10px',
            // },
        }),
    };


    const countryOptions = [...countries].sort((a, b) => a.name.localeCompare(b.name)).map((country) => ({
        label: `${country.dialCode}`,
        value: country.dialCode,
        flag: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`,
        code: country.code,
    }));

    return (
        <Select
            className={'select-container'}
            value={selectedCountry}
            onChange={setSelectedCountry}
            options={countryOptions}
            components={{
                IndicatorSeparator: () => null,
            }}
            formatOptionLabel={(e, {context}) =>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "transparent",
                    paddingLeft: '8px',
                    color: 'white',
                    fontSize: '18px'
                }}>
                    <img
                        src={e.flag}
                        alt={e.code}
                        style={{width: 20, height: 15, marginRight: 5}}
                    />
                    {e.value}
                </div>
            }
            styles={customStyles}
        />
    )
}